"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GroupVideoWelcomeModal = _interopRequireDefault(require("./GroupVideoWelcomeModal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _GroupVideoWelcomeModal.default;
exports.default = _default;